<template>
  <el-dialog
    v-model="isVisible"
    :id="id"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <dialog-success :title="$t('store-management.push.success.push-create')" :action="redirect" />
  </el-dialog>
</template>

<script>
// libs, helpers
import bus from '@/helpers/events/bus';
// components
import DialogSuccess from '@/components/_atoms/DialogSuccess';

export default {
  name: 'PushDialogSuccessModal',
  components: {
    DialogSuccess,
  },
  data() {
    return {
      id: 'push-dialog-success-modal',
      redirectId: null,
      redirectRouteName: null,
      isVisible: false,
    };
  },
  mounted() {
    bus.$on(`open-${this.id}`, ({ redirectId, redirectRouteName }) => {
      this.redirectId = redirectId || '';
      this.redirectRouteName = redirectRouteName || '';
      this.openModal();
    });
  },
  beforeUnmount() {
    bus.$off([`open-${this.id}`]);
  },
  methods: {
    openModal() {
      this.isVisible = true;
    },
    closeModal() {
      this.isVisible = false;
    },
    redirect() {
      this.closeModal();
      this.$router.push({
        name: this.redirectRouteName,
        params: {
          id: this.redirectId,
        },
      });
      bus.$emit('push-trigger-reload', { id: this.redirectId });
    },
  },
};
</script>

<style lang="scss" scoped>
#push-dialog-success-modal {
  padding: 0 50px;
  text-align: center;
}
</style>

<style lang="scss">
#push-dialog-success-modal {
  width: 540px;
  max-width: 540px;
  min-height: 300px;

  .el-dialog__body {
    padding: 40px 0;
  }
}
</style>
